import { useAuth } from './useAuth';
import { ADMIN_GROUP } from '../config/branding';

/** Cognito/Entra group that grants access to admin-only surfaces (e.g. Calibration).
 *  Env-driven (default `sdd-maturity-admin`) — see {@link ../config/branding}. Re-exported
 *  here so existing admin-gated call sites keep importing it from one place. */
export { ADMIN_GROUP };

/**
 * True when the authenticated user belongs to {@link ADMIN_GROUP}. Reads the
 * `groups` claim lifted off the id token by `useAuth`. Shared by every
 * admin-gated surface so the check lives in exactly one place.
 */
export function useIsAdmin(): boolean {
  const { user } = useAuth();
  const groups = user?.groups;
  return Array.isArray(groups) && groups.includes(ADMIN_GROUP);
}
